module.exports = __webpack_public_path__ + "img/img10.01994983.png";